import React from 'react';
import { Grid, Button, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { BOOKING_DETAIL } from '@shared/helpers/routes';
import LinkButton from './LinkButton';
import LogedUserButton from './LogedUserButton';
import { sxHeader } from './styles';

const HeaderRight = ({
  pageConfiguration,
  userToken,
  user,
  loginHandler,
  openAccountMenu,
  openMenuAccount,
  closeAccountMenu,
  backofficeRedirect,
  setIsHoveringBO,
  isHoveringBO,
  collegeRedirect,
  setIsHoveringCO,
  isHoveringCO,
  onClickHandler,
}) => {
  return (
    <Grid
      item
      xs={4}
      sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
    >
      {/* Header visible solo en lg+ */}
      <Grid
        container
        justifyContent="flex-end"
        alignItems="center"
        columnSpacing={1}
        sx={{
          display: { xs: 'none', lg: 'flex' },
          maxWidth: { lg: '550px', xl: '600px' },
          flexWrap: 'nowrap',
        }}
      >
        {pageConfiguration.site_functions.showRegisterButton && (
          <Grid item>
            <LinkButton
              route={BOOKING_DETAIL}
              text="Mi reserva"
              width="140px"
            />
          </Grid>
        )}

        <Grid item>
          {userToken ? (
            <LogedUserButton
              {...{
                openAccountMenu,
                user,
                openMenuAccount,
                closeAccountMenu,
                backofficeRedirect,
                pageConfiguration,
                setIsHoveringBO,
                isHoveringBO,
                collegeRedirect,
                setIsHoveringCO,
                isHoveringCO,
                loginHandler,
              }}
            />
          ) : (
            <Grid
              display="flex"
              flexDirection="row"
              alignItems="center"
              sx={{
                height: 49,
                padding: '12px',
              }}
            >
              <AccountCircleSharpIcon
                onClick={loginHandler}
                sx={{ mr: 1, cursor: 'pointer', fontSize: '30px' }}
              />
              <Typography
                onClick={loginHandler}
                id="loginButton"
                sx={{
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: 'black',
                  //pr: '20px',
                }}
              >
                Iniciar Sesión
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>

      {/* Botón hamburguesa visible solo hasta lg- */}
      <Button size="large" sx={sxHeader.buttonHide} onClick={onClickHandler}>
        <MenuIcon fontSize="large" sx={{ color: 'black' }} />
      </Button>
    </Grid>
  );
};

export default HeaderRight;
